import React, { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { WidgetArticleTitleContent, WidgetArticleTitleType, WidgetDisplayMode } from 'jamespot-user-api';
import { Widget, updateWidgetContent } from 'jamespot-front-business';
import styled from 'styled-components';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

const WidgetArticleTitle = commonComponentsRegistry.getLazyComponent('WidgetArticleTitle');

const CSSTextWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: text;
`;

const ToolWrapper = styled.div`
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    overflow: hidden;
    margin: 4px;
    border: 1px solid ${(props) => props.theme.color.grey1};
`;

const Tool = styled.button<{ isActive: boolean }>`
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: ${(props) => (props.isActive ? '1.0' : '.8')};
    background-color: ${(props) => (props.isActive ? props.theme.color.grey1 : props.theme.color.white)};
    &:hover {
        background-color: ${(props) => props.theme.color.grey1};
    }
`;

export const JRCWidgetArticleTitleWrapper = ({
    widget,
    inplace,
    mode,
    dataCy,
}: {
    widget: WidgetArticleTitleType;
    inplace: boolean;
    mode?: WidgetDisplayMode;
    dataCy?: string;
}) => {
    const { uniqid } = widget;
    const { text, color, heading } = widget.content;
    const dispatch = useAppDispatch();
    const isActive = useAppSelector((state) => Widget.selectors.isActive(state, uniqid), shallowEqual);

    useEffect(() => {
        dispatch(
            Widget.slice.actions.setWidgetState({
                uniqid,
                empty: !text || text.length === 0,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    return (
        <CSSTextWrapper>
            <WidgetArticleTitle
                dataCy={dataCy}
                text={text}
                color={color}
                heading={heading}
                autoFocus={isActive}
                inplace={inplace}
                mode={mode}
                onChange={(text) => {
                    dispatch(updateWidgetContent<WidgetArticleTitleContent>(uniqid, { text }));
                }}
            />
            {isActive && mode === 'edit' ? (
                <Toolbar
                    heading={heading}
                    onClick={(heading) => {
                        dispatch(updateWidgetContent<WidgetArticleTitleContent>(uniqid, { heading }));
                    }}
                />
            ) : (
                <></>
            )}
        </CSSTextWrapper>
    );
};

export const Toolbar = ({ heading = 'h1', onClick }: { heading?: string; onClick: (size: string) => void }) => {
    const sizes: string[] = ['h1', 'h2', 'h3', 'h4'];
    return (
        <ToolWrapper>
            {sizes.map((sizeValue, index: number) => (
                <Tool key={index} isActive={heading === sizeValue} onClick={() => onClick(sizeValue)}>
                    {sizeValue}
                </Tool>
            ))}
        </ToolWrapper>
    );
};
